// Shared email types (spec 02 §3, spec 08). Web-standard TS only: imported by Deno functions and the SPA.
export type Lang = "fr" | "en";
export type TemplateKind =
  | "marketing"
  | "sequence"
  | "transactional"
  | "one_to_one";
export type ConsentBasis =
  | "express"
  | "implied_conspicuous_publication"
  | "implied_existing_relationship"
  | "implied_inquiry"
  | "none";

export type TemplateRow = {
  id: number;
  name: string;
  kind: TemplateKind;
  language: Lang;
  subject: string;
  preheader: string | null;
  body_html: string;
  body_text: string | null;
};

/** GAVION video-campaign: a file of email_templates.attachments (66_), stored in the private template-attachments bucket. */
export type TemplateFileRef = {
  path: string;
  name: string;
  contentType: string;
  size: number;
};

/** CASL sender identification (owner decision 2026-10-11). Config may override the postal address. */
export const CASL_ORG = Object.freeze({
  legalName: "Gavion inc.",
  contactEmail: "sales@gavion.ai",
  postalAddress: "2901, rue Rachel Est, Montréal (QC) H1W 1B2",
});
